import * as React from "react";

const RecommendationCardSvg = (props: any) => (
  <svg
    width={251}
    height={102}
    viewBox="0 0 251 102"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#filter0_dd_9347_2403)">
      <g clipPath="url(#clip0_9347_2403)">
        <rect
          x={26}
          y={2}
          width={172.184}
          height={107}
          rx={9.83908}
          fill="white"
        />
        <rect
          x={142.839}
          y={6.91309}
          width={47.9655}
          height={9.83908}
          rx={2.45977}
          fill="#060216"
          fillOpacity={0.08}
        />
        <g clipPath="url(#clip1_9347_2403)">
          <path
            d="M188.652 14.6062L187.317 13.2717"
            stroke="#060216"
            strokeOpacity={0.24}
            strokeWidth={0.614942}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M185.578 13.9896C186.937 13.9896 188.038 12.8883 188.038 11.5298C188.038 10.1713 186.937 9.07007 185.578 9.07007C184.22 9.07007 183.118 10.1713 183.118 11.5298C183.118 12.8883 184.22 13.9896 185.578 13.9896Z"
            stroke="#060216"
            strokeOpacity={0.24}
            strokeWidth={0.614942}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <mask id="path-6-inside-1_9347_2403" fill="white">
          <path d="M26 2H57.977V109H26V2Z" />
        </mask>
        <path d="M26 2H57.977V109H26V2Z" fill="#FAFAFA" />
        <path
          d="M57.977 2H56.7471V109H57.977H59.2069V2H57.977Z"
          fill="#F1F5F9"
          mask="url(#path-6-inside-1_9347_2403)"
        />
        <rect
          x={30.9196}
          y={21.6814}
          width={19.6782}
          height={4.91954}
          rx={2.45977}
          fill="#060216"
          fillOpacity={0.08}
        />
        <rect
          x={30.9196}
          y={27.8254}
          width={19.6782}
          height={4.91954}
          rx={2.45977}
          fill="#060216"
          fillOpacity={0.08}
        />
        <rect
          x={30.9196}
          y={33.9788}
          width={19.6782}
          height={4.91954}
          rx={2.45977}
          fill="#060216"
          fillOpacity={0.08}
        />
        <rect
          x={30.9196}
          y={6.91309}
          width={9.83908}
          height={9.83908}
          rx={2.45977}
          fill="#060216"
          fillOpacity={0.08}
        />
      </g>
      <rect
        x={26.6149}
        y={2.61494}
        width={170.954}
        height={105.77}
        rx={9.22414}
        stroke="#F1F5F9"
        strokeWidth={1.22988}
      />
    </g>
    <g filter="url(#filter1_d_9347_2403)">
      <rect
        x={67.9422}
        y={27.3542}
        width={201.985}
        height={28.6973}
        rx={8.82994}
        fill="white"
        shapeRendering="crispEdges"
      />
      <rect
        x={68.4941}
        y={27.9061}
        width={200.881}
        height={27.5936}
        rx={8.27807}
        stroke="#F1F5F9"
        strokeWidth={1.10374}
        shapeRendering="crispEdges"
      />
      <rect
        x={76.7722}
        y={36.1841}
        width={69.5358}
        height={11.0374}
        rx={5.51872}
        fill="#060216"
        fillOpacity={0.08}
      />
      <rect
        x={157.345}
        y={36.1841}
        width={46.3572}
        height={11.0374}
        rx={5.51872}
        fill="#060216"
        fillOpacity={0.08}
      />
      <rect
        x={214.74}
        y={36.1841}
        width={46.3572}
        height={11.0374}
        rx={5.51872}
        fill="#060216"
        fillOpacity={0.08}
      />
    </g>
    <g filter="url(#filter2_d_9347_2403)">
      <rect
        x={78.9797}
        y={63.7751}
        width={201.985}
        height={28.6973}
        rx={8.82994}
        fill="white"
        shapeRendering="crispEdges"
      />
      <rect
        x={79.5315}
        y={64.327}
        width={200.881}
        height={27.5936}
        rx={8.27807}
        stroke="#F1F5F9"
        strokeWidth={1.10374}
        shapeRendering="crispEdges"
      />
      <rect
        x={87.8096}
        y={72.605}
        width={69.5358}
        height={11.0374}
        rx={5.51872}
        fill="#060216"
        fillOpacity={0.08}
      />
      <rect
        x={168.383}
        y={72.605}
        width={46.3572}
        height={11.0374}
        rx={5.51872}
        fill="#060216"
        fillOpacity={0.08}
      />
      <rect
        x={225.777}
        y={72.605}
        width={46.3572}
        height={11.0374}
        rx={5.51872}
        fill="#060216"
        fillOpacity={0.08}
      />
    </g>
    <rect y={52} width={272} height={63} fill="url(#paint0_linear_9347_2403)" />
    <defs>
      <filter
        id="filter0_dd_9347_2403"
        x={23}
        y={0}
        width={178.184}
        height={113}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feMorphology
          radius={1}
          operator="erode"
          in="SourceAlpha"
          result="effect1_dropShadow_9347_2403"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9347_2403"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={1.5} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="effect1_dropShadow_9347_2403"
          result="effect2_dropShadow_9347_2403"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect2_dropShadow_9347_2403"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_9347_2403"
        x={67.9422}
        y={27.3542}
        width={201.985}
        height={29.6973}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9347_2403"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_9347_2403"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d_9347_2403"
        x={78.9797}
        y={63.7751}
        width={201.985}
        height={29.6973}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={1} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_9347_2403"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_9347_2403"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_9347_2403"
        x1={136}
        y1={96.6727}
        x2={136}
        y2={52}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F3F4F6" />
        <stop offset={1} stopColor="#F3F4F6" stopOpacity={0} />
      </linearGradient>
      <clipPath id="clip0_9347_2403">
        <rect
          x={26}
          y={2}
          width={172.184}
          height={107}
          rx={9.83908}
          fill="white"
        />
      </clipPath>
      <clipPath id="clip1_9347_2403">
        <rect
          width={7.37931}
          height={7.37931}
          fill="white"
          transform="translate(182.195 8.1438)"
        />
      </clipPath>
    </defs>
  </svg>
);

export default RecommendationCardSvg;
